import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const go = (id) => {
    if (window.location.pathname !== "/") {
      navigate("/");
      setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="border-t border-white/10 py-12 px-6 bg-[#02050F] font-mono-lbl text-xs text-white/50" data-testid="site-footer">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <span className="font-disp text-lg text-white uppercase tracking-wider" data-testid="footer-brand">LuxeRay Smart Homes Pvt Ltd</span>
        <div className="flex gap-6 flex-wrap justify-center">
          <button onClick={() => go("township")} className="hover:text-white transition-colors" data-testid="footer-townships-link">Townships</button>
          <button onClick={() => go("automation")} className="hover:text-white transition-colors" data-testid="footer-homes-link">Smart Homes</button>
          <button onClick={() => { navigate("/mart"); window.scrollTo(0, 0); }} className="hover:text-white transition-colors" data-testid="footer-shop-link">AIoT Mart</button>
          <button onClick={() => go("app")} className="hover:text-white transition-colors" data-testid="footer-app-link">Mobile App</button>
        </div>
        <div className="text-white/40" data-testid="footer-copyright">© 2025 LuxeRay. All rights reserved.</div>
      </div>
    </footer>
  );
}
